export default __webpack_public_path__ + "c22575a28233bb3dadef54d42dc10860.png";